import { useState } from 'preact/hooks';
import { api, guardarToken } from '../api';
import { Logo } from '../iconos';

export function Ingreso({ alEntrar }: { alEntrar: () => void }) {
  const [correo, setCorreo] = useState('');
  const [clave, setClave] = useState('');
  const [codigo, setCodigo] = useState('');
  const [parcial, setParcial] = useState<string | null>(null);
  const [error, setError] = useState('');
  const [ocupado, setOcupado] = useState(false);

  async function enviar(e: Event) {
    e.preventDefault();
    setError(''); setOcupado(true);
    try {
      if (!parcial) {
        const r = await api<{ token: string; requiere2fa: boolean }>('/api/sesion', { cuerpo: { correo, clave } });
        if (r.requiere2fa) setParcial(r.token);
        else { guardarToken(r.token); alEntrar(); }
      } else {
        const r = await api<{ token: string }>('/api/sesion/2fa', { cuerpo: { token: parcial, codigo } });
        guardarToken(r.token); alEntrar();
      }
    } catch (err) { setError((err as Error).message); } finally { setOcupado(false); }
  }

  return (
    <div class="ingreso">
      <form class="tarjeta" onSubmit={enviar}>
        <Logo />
        <h1 style="font-size:20px">Ingresar</h1>
        {!parcial ? (
          <>
            <div class="campo"><label for="correo">Correo</label><input id="correo" type="email" autocomplete="username" required value={correo} onInput={(e) => setCorreo((e.target as HTMLInputElement).value)} /></div>
            <div class="campo"><label for="clave">Contraseña</label><input id="clave" type="password" autocomplete="current-password" required value={clave} onInput={(e) => setClave((e.target as HTMLInputElement).value)} /></div>
          </>
        ) : (
          <div class="campo"><label for="codigo">Código del segundo factor</label><input id="codigo" inputMode="numeric" autocomplete="one-time-code" pattern="[0-9 ]{6,7}" required autofocus value={codigo} onInput={(e) => setCodigo((e.target as HTMLInputElement).value)} /><div class="sub" style="margin-top:6px">Abre tu aplicación de autenticación y escribe el código de seis dígitos.</div></div>
        )}
        {error && <div class="error">{error}</div>}
        <button class="boton marino" type="submit" disabled={ocupado}>{parcial ? 'Confirmar' : 'Entrar'}</button>
      </form>
    </div>
  );
}
